import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
const Login = () => import('@/views/Login.vue')
const Layout = () => import('@/views/Layout.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const DiskToken = () => import('@/views/DiskToken.vue')
const ApiInterface = () => import('@/views/ApiInterface.vue')
const Search = () => import('@/views/Search.vue')
const CacheManage = () => import('@/views/CacheManage.vue')
const FailedResources = () => import('@/views/FailedResources.vue')
const Announcement = () => import('@/views/Announcement.vue')
const LinkTransfer = () => import('@/views/LinkTransfer.vue')
const ResourceTracking = () => import('@/views/ResourceTracking.vue')
const IpAccess = () => import('@/views/IpAccess.vue')
const AgentMonitor = () => import('@/views/AgentMonitor.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '仪表板', icon: 'el-icon-s-home' }
      },
      {
        path: 'disk-token',
        name: 'DiskToken',
        component: DiskToken,
        meta: { title: '网盘Token管理', icon: 'el-icon-upload' }
      },
      {
        path: 'interface-manage',
        name: 'InterfaceManage',
        component: ApiInterface,
        meta: { title: '接口管理', icon: 'el-icon-connection' }
      },
      {
        path: 'search',
        name: 'Search',
        component: Search,
        meta: { title: '资源搜索', icon: 'el-icon-search' }
      },
      {
        path: 'cache-manage',
        name: 'CacheManage',
        component: CacheManage,
        meta: { title: '缓存管理', icon: 'el-icon-files' }
      },
      {
        path: 'failed-resources',
        name: 'FailedResources',
        component: FailedResources,
        meta: { title: '失败资源管理', icon: 'el-icon-warning-outline' }
      },
      {
        path: 'site-config',
        name: 'SiteConfig',
        component: () => import('@/views/SiteConfig'),
        meta: { title: '网站配置', icon: 'el-icon-setting' }
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: Announcement,
        meta: { title: '公告管理', icon: 'el-icon-message' }
      },
      {
        path: 'link-transfer',
        name: 'LinkTransfer',
        component: LinkTransfer,
        meta: { title: '一键转链接', icon: 'el-icon-share' }
      },
      {
        path: 'resource-tracking',
        name: 'ResourceTracking',
        component: ResourceTracking,
        meta: { title: '资源追踪', icon: 'el-icon-data-line' }
      },
      {
        path: 'ip-access',
        name: 'IpAccess',
        component: IpAccess,
        meta: { title: 'IP访问监控', icon: 'el-icon-view' }
      },
      {
        path: 'agent-monitor',
        name: 'AgentMonitor',
        component: AgentMonitor,
        meta: { title: 'AI助手监控', icon: 'el-icon-monitor' }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/ChangePassword'),
        meta: { title: '修改密码', icon: 'el-icon-lock' }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')

  if (to.path === '/login') {
    // 如果已经登录，跳转到首页
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    // 对于需要认证的路由
    if (!token) {
      // 没有token，跳转到登录页
      next('/login')
    } else {
      // 有token，允许访问
      next()
    }
  }
})

export default router
